import React from "react";
import SubjectFilterForm from "./SubjectFilterForm";

const SubjectFilter: React.FC = () => {
  return (
      <SubjectFilterForm />
  );
};

export default SubjectFilter;
